module.exports = __webpack_public_path__ + "img/keyBuckle_1.c4e1637a.jpg";